module.exports = ["landsat","modis","sentinel-1","sentinel-2-l2a","hls2"]